import { Link } from "@StarberryUtils"
import React, { useState, useEffect } from "react"
import { Container, Row, Col } from "react-bootstrap"
import parse from 'html-react-parser';
import Slider from "react-slick"
import axios from "axios"
import "./OfficePropery.scss"
import ScrollAnimation from "react-animate-on-scroll"
import { numberWithCommas } from "@Components/common/common-functions.js"
const SimilarPropery = props => {
  

  const [propItems, setPropItems] = useState([])
  const strapiconfig = {
    headers: {
        Authorization:
            `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
    },
  }
  const getitems = async url => {
    try {
      const { data } = await axios.get(url, strapiconfig)
      // 
      // console.log("PropertySimilar", data)
      setPropItems(data)
    } catch (error) {
      // console.error(error)
    }
  }

  useEffect(() => {
    let area = props.area ? props.area : "";
    let type = props.Type ? props.Type : "";
    console.log('office_data type', type);
    let saleurl = process.env.GATSBY_STRAPI_SRC + "/properties?department=residential&search_type=sales&status=For Sale&_limit=6&_sort=createdAt:DESC&publish=true&";
    let renturl = process.env.GATSBY_STRAPI_SRC + "/properties?department=residential&search_type=lettings&status=To Let&_limit=6&_sort=createdAt:DESC&publish=true";
    if (area) {
      saleurl = saleurl + "&location_contains=" + area ;
      renturl = renturl + "&location_contains=" + area ;
    }
    if (type == 'Manchester_Sale_Properties' || type == 'Hale_Sale_Properties') {
      getitems(saleurl)
    }
    if (type == 'Manchester_Rent_Properties' || type == 'Hale_Rent_Properties') {
      getitems(renturl)
    }
  }, [])
  //
  const settings = {
    dots: false,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    mobileFirst: true,
    responsive: [
      // {
      //   breakpoint: 9999,
      //   settings: "unslick",
      // },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  }

  return (
    <>
      {
      propItems.length > 0 ?
        <div className="case-studies similar-properties">
          <Container>
            <Row>
              <Col xs>
                <div className="case-studies-block">
                  <div className="case-studies-content">
                    <h2 className="d-lg-none title">{props.Title}</h2>
                    <ScrollAnimation animateIn="fadeIn">
                      <h2 className="d-none d-lg-block title">
                        {props.Title}
                      </h2>
                      <div className="description">{parse(props.Content)}</div>
                    </ScrollAnimation>
                  </div>
                  <div className="case-studies-list slick-pagination">
                    <Slider {...settings}>
                      {propItems &&
                        propItems.map(hit => {
                          // property details url structure
                          let uriStr = "";

                          if( hit.search_type === "sales" ) {
                            uriStr = `property-for-sale/`
                          } else if ( hit.search_type === "lettings" ) {
                            uriStr = `property-to-rent/`
                          }

                          // property details url structure

                          return (
                            <a href={'/'+uriStr+hit.slug+'-'+hit.id+'/'} className="case-studies-news img-zoom">
                              <ScrollAnimation animateIn="fadeIn" dealy={500}>
                                <div className="case-studies-img">
                                  <img src={hit.images[0].hd_url || hit?.images[0]?.url} alt="" />
                                </div>
                                <div className="case-studies-title">
                                  <div className="detail-head d-flex align-items-center justify-content-between">
                                    <h3 className="">
                                      <span className="price">
                                      {
                                        hit.search_type === "lettings" ?
                                        <>&pound;{numberWithCommas(Math.round(hit.price))}</>
                                        :
                                        <>&pound;{numberWithCommas(hit.price)}</>
                                      }
                                      </span>
                                      <span className="">
                                        <Link href={'/'+uriStr+hit.slug+'-'+hit.id+'/'}>{hit.title}</Link>
                                      </span>
                                    </h3>
                                  </div>
                                  {/* <h3>
                                    <Link href={'/'+uriStr+hit.slug+'-'+hit.id+'/'}>{hit.title}</Link>
                                  </h3> */}
                                  <span className="add-txt">
                                    {hit.display_address}
                                  </span>
                                </div>
                              </ScrollAnimation>
                            </a>
                          )
                        })}
                    </Slider>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      : '' }
    </>
  )
}

export default SimilarPropery
